import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = {
  key: 3,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = {
  key: 4,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm" }
const _hoisted_20 = {
  key: 5,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_21 = { class: "control-label col-sm-6" }
const _hoisted_22 = { class: "col-sm" }
const _hoisted_23 = {
  key: 6,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_24 = { class: "control-label col-sm-6" }
const _hoisted_25 = { class: "col-sm" }
const _hoisted_26 = {
  key: 7,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_27 = { class: "control-label col-sm-6" }
const _hoisted_28 = { class: "col-sm" }
const _hoisted_29 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_30 = { class: "control-label col-sm-6" }
const _hoisted_31 = { class: "col-sm" }
const _hoisted_32 = {
  key: 8,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_33 = { class: "control-label col-sm-6" }
const _hoisted_34 = { class: "col-sm" }
const _hoisted_35 = {
  key: 9,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_36 = { class: "control-label col-sm-6" }
const _hoisted_37 = { class: "col-sm" }

import { watch , ref, inject} from 'vue'
import { usePreventivo } from '../../composable/usePreventivo'
import FormFamigliaHelper from "../../pages/preventivi/json/famiglia/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import FormSocietarioHelper from "../../pages/preventivi/json/societario/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormFamigliaFondoPatrimoniale',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione','update:validate-to'],
  setup(__props, { emit: __emit }) {

const $AxiosClient = inject('$AxiosClient');
const {
  categorieValidazione
} = usePreventivo()
const props = __props
const emits = __emit
let validazione;
const validazioneEquoCompenso = ref();
const calcoloValoreDaRendita = ref(false);
const testoInfoCompilazione = ref([]);
const { regimeFiscale } = inject('regimeFiscale')
let indexHelperClosing = '';
switch (props.formName) {
  case 'costituzioneFondoPatrimoniale':
    validazione = categorieValidazione.categoriaFamiglia['sottocategoriaFondoPatrimoniale']['costituzioneFondoPatrimoniale'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaFamiglia['sottocategoriaFondoPatrimoniale']['costituzioneFondoPatrimoniale'];
    testoInfoCompilazione.value =  FormFamigliaHelper.sottocategoriaFondoPatrimoniale[props.formName];
    indexHelperClosing = {
      calcolo:  FormFamigliaHelper.sottocategoriaFondoPatrimoniale[props.formName],
      dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
    }
    break
}
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if (validazione) {
  validazione.tipo_preventivo.value = 'famiglia/fondo_patrimoniale/' + props.tipoPreventivo.data.url
}
function tipoFondo(event){
if(event.target.value == 'con_trasferimento_di_beni') {
  // validazione.valore_beni.required = true;
  validazione.categoria.value = 'a_favore_del_coniuge_e_di_parenti_in_linea_retta'
  validazione.tipologia.required = true;
} else {
  validazione.tipologia.required = false;
}
  validazione.tipologia.value = ''
  validazione.rendita_catastale_prima_casa.value = ''
  validazione.rendita_catastale_seconda_casa.value = ''
  validazione.valore_prima_casa.value = ''
  validazione.valore_altri_beni.value = ''
  validazione.tipologia_immobile.value = ''
  validazione.tipologia_immobile.required = false;
  validazione.donazioni_precedenti.value = ''
  validazione.numero_conservatorie.value = '1'
  validazione.portatore_handicap.value = '0'
}
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo')
}, { deep: true })
function controlloNumeroConservatorie(event){
  let numero = event.target.value;
  if(numero > 1){
    validazione.imposta_ipotecaria_per_ciascuna_conservatoria.required = true;
  } else {
    validazione.imposta_ipotecaria_per_ciascuna_conservatoria.required = false;
  }
}
function tipologia (event) {
  if(event.target.value == 'valore_suggerito_da_rendita_catastale'){
    validazione.rendita_catastale_prima_casa.value = '0'
    validazione.tipologia_immobile.required = false;
    validazione.tipologia_immobile.value = '';
    validazione.tipologia_immobile.required = true;
    calcoloValoreDaRendita.value = true;
    validazione.abilitare_equo_compenso.value = 0;
    validazione.tipologia_tabella_calcolo.value = '';
  } else {
    validazione.abilitare_equo_compenso.value = 0;
    validazione.tipologia_immobile.required = false;
    validazione.rendita_catastale_prima_casa.value = '';
    validazione.tipologia_immobile.value = '';
    validazione.rendita_catastale_seconda_casa.value = '0';
    validazione.valore_prima_casa.value = '';
    validazione.valore_altri_beni.value = '';
    calcoloValoreDaRendita.value = false;
    validazione.tipologia_tabella_calcolo.value = '';
  }
}
function updateTipologiaImmobile (event) {
  if (event.target) {
    let valore = formatterSomma(event.target.value.replace('€', ''))
    if (valore > 0) {
      validazione.tipologia_immobile.required = true
    } else {
      validazione.tipologia_immobile.required = false
      validazione.tipologia_immobile.value = ''
    }
  }
}

async function calcolaValore(event){
  if(event.target.name == 'rendita_catastale_seconda_casa'){
    updateTipologiaImmobile(event)
  }
  if(validazione.rendita_catastale_prima_casa.value == ''){
    validazione.rendita_catastale_prima_casa.value = '0'
  }
  if(validazione.rendita_catastale_seconda_casa.value == ''){
    validazione.rendita_catastale_seconda_casa.value = '0'
  }
  if (validazione.tipologia_immobile.value == '') {
    return;
  }
  let valoreCalcolato = await $AxiosClient.post('Utilita', 'calcolo_valore_da_rendita_catastale',{
    'rendita_catastale_prima_casa': validazione.rendita_catastale_prima_casa.value,
    'rendita_catastale_seconda_casa': validazione.rendita_catastale_seconda_casa.value,
    'tipologia_immobile': validazione.tipologia_immobile.value,
    'tipo_utilita': 'immobiliare/calcolo_valore_da_rendita_catastale'
  },{messages:false});

  if (valoreCalcolato.esito === 'ok') {
    validazione.valore_prima_casa.value = valoreCalcolato.valore_prima_casa;
    validazione.valore_altri_beni.value = valoreCalcolato.valore_altri_beni;
  }
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'costituzioneFondoPatrimoniale')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).tipo_fondo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_fondo.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_select, {
                name: "tipo_fondo",
                options: [{name: 'Senza trasferimento di beni', value: 'senza_trasferimento_di_beni'},
            {name: 'Con trasferimento di beni', value: 'con_trasferimento_di_beni'}
            ],
                onChange: _cache[0] || (_cache[0] = $event => (tipoFondo($event))),
                state: __props.readonly == true ?'disable':'',
                isSelected: _unref(validazione).tipo_fondo.value != '',
                validateTo: _unref(validazione).tipo_fondo,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).tipo_fondo) = $event))
              }, null, 8 /* PROPS */, ["state", "isSelected", "validateTo"])
            ])
          ]),
          (_unref(validazione).tipo_fondo.value == 'con_trasferimento_di_beni')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(validazione).tipologia.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipologia.ref]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_base_select, {
                    name: "tipologia",
                    options: [
            {name: 'Valore suggerito da rendita catastale', value: 'valore_suggerito_da_rendita_catastale'},
            {name: 'Valore libero', value: 'valore_libero'}],
                    onChange: _cache[2] || (_cache[2] = $event => (tipologia($event))),
                    isSelected: _unref(validazione).tipologia.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).tipologia,
                    "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).tipologia) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipo_fondo.value == 'con_trasferimento_di_beni' && _unref(validazione).tipologia.value == 'valore_suggerito_da_rendita_catastale')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_prima_casa.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_prima_casa.ref]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_input_text, {
                    id: "rendita_catastale_prima_casa",
                    name: "rendita_catastale_prima_casa",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    onChange: _cache[4] || (_cache[4] = $event => (calcoloValoreDaRendita.value ? calcolaValore($event): '')),
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).rendita_catastale_prima_casa,
                    "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).rendita_catastale_prima_casa) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipo_fondo.value == 'con_trasferimento_di_beni' && _unref(validazione).tipologia.value == 'valore_suggerito_da_rendita_catastale')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_seconda_casa.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_seconda_casa.ref]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_base_input_text, {
                    id: "rendita_catastale_seconda_casa",
                    name: "rendita_catastale_seconda_casa",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    onChange: _cache[6] || (_cache[6] = $event => (calcoloValoreDaRendita.value ? calcolaValore($event): '')),
                    "validate-to": _unref(validazione).rendita_catastale_seconda_casa,
                    "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).rendita_catastale_seconda_casa) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipo_fondo.value == 'con_trasferimento_di_beni' && _unref(validazione).tipologia.value == 'valore_libero')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_prima_casa.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_prima_casa.ref]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_base_input_text, {
                    id: "valore_prima_casa",
                    name: "valore_prima_casa",
                    class: "placeholder-right crm:text-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore_prima_casa,
                    "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).valore_prima_casa) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipo_fondo.value == 'con_trasferimento_di_beni' && _unref(validazione).tipologia.value == 'valore_libero')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_altri_beni.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_altri_beni.ref]
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_base_input_text, {
                    id: "valore_altri_beni",
                    name: "valore_altri_beni",
                    class: "placeholder-right crm:text-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore_altri_beni,
                    "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).valore_altri_beni) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipo_fondo.value == 'con_trasferimento_di_beni')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_unref(validazione).categoria.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.categoria.ref]
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_base_select, {
                    name: "categoria",
                    options: [{name: 'A favore del coniuge e di parenti in linea retta', value: 'a_favore_del_coniuge_e_di_parenti_in_linea_retta'},
            {name: 'A favore di Fratelli e Sorelle (non di loro rappresentanti)', value: 'a_favore_di_fratelli_e_sorelle_non_di_loro_rappresentanti'},
            {name: 'A favore di altri parenti fino al 4° Affini in linea retta - in linea collaterale fino al 3° - (genero nuora)', value: 'a_favore_di_altri_parenti_fino_al_quarto_grado_affini_in_linea_retta'},
            {name: ' A favore di tutti gli altri soggetti', value: 'a_favore_di_tutti_gli_altri_soggetti'}],
                    isSelected: _unref(validazione).categoria.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).categoria,
                    "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).categoria) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipo_fondo.value == 'con_trasferimento_di_beni' && _unref(validazione).tipologia.value == 'valore_suggerito_da_rendita_catastale')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_24, [
                  _createTextVNode(_toDisplayString(_unref(validazione).tipologia_immobile.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipologia_immobile.ref]
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_base_select, {
                    name: "tipologia_immobile",
                    options: [{name: 'Tutti i fabb. abitativi e pertinenze (A,C escluse A/10 e C/1)', value: 'cat_a_c'},
            {name: 'Cat. B (Immobili destinati a servizi)', value: 'cat_b'},
            {name: 'Cat. D + A/10 (Uffici e studi privati / Destinazione speciale)', value: 'cat_d_a10'},
            {name: 'Cat. E + C/1 (Negozi / Destinazione particolare)', value: 'cat_e_c1'},
            {name: 'Cat. T (Terreni agricoli)', value: 'cat_t'}],
                    onChange: _cache[11] || (_cache[11] = $event => (calcoloValoreDaRendita.value ? calcolaValore($event): '')),
                    isSelected: _unref(validazione).tipologia_immobile.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).tipologia_immobile,
                    "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).tipologia_immobile) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipo_fondo.value == 'con_trasferimento_di_beni' && (_unref(validazione).categoria.value == 'a_favore_del_coniuge_e_di_parenti_in_linea_retta' || _unref(validazione).categoria.value == 'a_favore_di_fratelli_e_sorelle_non_di_loro_rappresentanti'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_27, [
                  _createTextVNode(_toDisplayString(_unref(validazione).donazioni_precedenti.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.donazioni_precedenti.ref]
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_base_input_text, {
                    id: "donazioni_precedenti",
                    name: "donazioni_precedenti",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).donazioni_precedenti,
                    "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).donazioni_precedenti) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_29, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_30, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_base_input_text, {
                id: "numero_conservatorie",
                name: "numero_conservatorie",
                class: "placeholder-right crm:text-right",
                disabled: __props.readonly,
                onChange: _cache[14] || (_cache[14] = $event => (controlloNumeroConservatorie($event))),
                placeholder: "Indicare numero conservatorie",
                "validate-to": _unref(validazione).numero_conservatorie,
                "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).numero_conservatorie) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          (_unref(validazione).tipo_fondo.value == 'senza_trasferimento_di_beni' && _unref(validazione).numero_conservatorie.value > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_33, [
                  _createTextVNode(_toDisplayString(_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.imposta_ipotecaria_per_ciascuna_conservatoria.ref]
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_base_select, {
                    name: "imposta_ipotecaria_per_ciascuna_conservatoria",
                    options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                    isSelected: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria,
                    "onUpdate:validateTo": _cache[16] || (_cache[16] = $event => ((_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipo_fondo.value == 'con_trasferimento_di_beni')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_36, [
                  _createTextVNode(_toDisplayString(_unref(validazione).portatore_handicap.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.portatore_handicap.ref]
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "portatore_handicap",
                    label: "Sì",
                    "validate-to": _unref(validazione).portatore_handicap,
                    "onUpdate:validateTo": _cache[17] || (_cache[17] = $event => ((_unref(validazione).portatore_handicap) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          (_unref(validazione).tipologia.value == 'valore_suggerito_da_rendita_catastale')
            ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                key: 10,
                "input-riferimento-calcolo": ['valore_prima_casa','valore_altri_beni'],
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipologia.value == 'valore_libero')
            ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                key: 11,
                "input-riferimento-calcolo": ['valore_prima_casa','valore_altri_beni'],
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}